import axios from 'axios'
import firebase from 'firebase/app'
import { DEMO_MODE } from './demo/demo-mode'
import { demoAdapter } from './demo/mock-api'

const _HTTP = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? 'https://legacy-api.inobram.com.br/api/v1'
    // ? 'https://inobram-platform.appspot.com/api/v1'
    : 'http://localhost:8000/api/v1',
  // baseURL: 'https://inobram-platform.appspot.com/api/v1',
  // baseURL: 'https://dev-dot-inobram-platform.appspot.com/api/v1',
  timeout: 60000, // 60 seconds
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

_HTTP.interceptors.request.use(
  (config) => {
    return firebase.auth().currentUser.getIdToken().then((idToken) => {
      config.headers.Authorization = `jwt ${idToken}`
      return config
    })
  }, (err) => {
  return Promise.reject(err)
})

var baseURL

if (process.env.NODE_ENV === 'production') {
  baseURL = 'https://api.platform.inobram.com.br/v2'
} else if (process.env.NODE_ENV === 'staging') {
  baseURL = 'https://dev.api.platform.inobram.com.br/v2'
} else {
  baseURL = process.env.API_V2_BASE_URL || 'http://localhost:3333/v2'
}

const _HTTP_API_V2 = axios.create({
  baseURL: baseURL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

_HTTP_API_V2.interceptors.request.use(
  (config) => {
    return firebase.auth().currentUser.getIdToken().then((idToken) => {
      config.headers.Authorization = `Bearer ${idToken}`
      config.headers.userId = firebase.auth().currentUser.uid
      return config
    })
  }, (err) => {
  return Promise.reject(err)
})

// Demo build: serve every request from the in-browser fake API instead of the
// network, so the app runs with no backend.
if (DEMO_MODE) {
  _HTTP.defaults.adapter = demoAdapter
  _HTTP_API_V2.defaults.adapter = demoAdapter
}

export const HTTP = _HTTP
export const HTTP_API_V2 = _HTTP_API_V2



// WEBPACK FOOTER //
// ./src/http-common.js